<template>
  <img :src="src ? src : default_src" v-lazy="src ? src : default_src">
</template>
<script>
import default_url from '@/assets/images/html/loading.gif'
export default {
  name: "ImgLazy",
  componentName: "ImgLazy",

  data () {
    return {
    }
  },
  props: {
    src: {
      type: String,
      default: '',
    },
    default_src: {
      type: String,
      default: default_url,
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/lazy/imgLazy.vue